import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { CampiService } from 'src/app/services/campi.service';

@Component({
  selector: 'app-gestione-campi-export-dialog',
  templateUrl: './gestione-campi-export-dialog.component.html',
  styleUrls: ['./gestione-campi-export-dialog.component.css']
})
export class GestioneCampiExportDialogComponent implements OnInit, AfterViewInit {

  idEvento:number;

  dataSource: MatTableDataSource<ModelEventiCalamitosi.CampoGestibileExportDTO> = new MatTableDataSource();
  displayedColumns:string[] = ['templateAppartenenza','nomeCampo','visualizzabileNelReport']

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModelEventiCalamitosi.DialogData,
    public dialogRef: MatDialogRef<GestioneCampiExportDialogComponent>,
    private alertsCenterService: AlertsCenterService,
    private campoSvc:CampiService) {

      this.campoSvc.getCampiGestibiliPerExport(data.idEvento).subscribe(
        res => {this.dataSource.data = res},
        err => {
          this.alertsCenterService.showAlert({
            message: 'Errore in recupero campi gestibili per export excell',
            type: 'danger',
            autoClosable: false,
          });
        }
      )
    }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getNomeAndTPTemplate(element:ModelEventiCalamitosi.CampoGestibileExportDTO) {
    let nomeDaMostrare: string = ''
    if(element.templateAppartenenza !== null && element.tipologiaTemplate !== null) {
       nomeDaMostrare += element.templateAppartenenza;
       // Sono obbligato a fare così perchè lo switch è un implicito === e risulta:
       // element.tipologiaTemplate == 1 true
       // element.tipologiaTemplate === 1 false (switch non funzionerebbe)
       let tipologia: number = Number.parseInt(element.tipologiaTemplate.toString())
      switch (tipologia) {
          case 1:
            nomeDaMostrare += ' / Pubblico'
          break;
          case 2:
            nomeDaMostrare += ' / Privato'
          break;
          case 3:
            nomeDaMostrare += ' / Economico'
          break;
          case 4:
            nomeDaMostrare += ' / Libero'
          break;
        default:
          break;
      }
    }
    // Caso campi indipendenti da template
    else if (element.templateAppartenenza !== null && element.templateAppartenenza !== '') {
      nomeDaMostrare = element.templateAppartenenza
    }
    return nomeDaMostrare;
    }

    setAll(event:boolean){
     this.dataSource.data.forEach( campo => {campo.visualizzabileNelReport = event})

    }

    confirmAndSendList() {
       // Mando solo i campi con visualizzabile a true
       let listaCampiVisualizzabili = this.dataSource.data.filter( campo => campo.visualizzabileNelReport )
        this.dialogRef.close(listaCampiVisualizzabili);
    }

}
